// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './profile-api';

export const useGetProfile: typeof hookExports.useGetProfile = hookExports.useGetProfile;
export const useLazyGetProfile: typeof hookExports.useLazyGetProfile =
  hookExports.useLazyGetProfile;
export const useUpdateProfile: typeof hookExports.useUpdateProfile = hookExports.useUpdateProfile;
export const useListProfileTenants: typeof hookExports.useListProfileTenants =
  hookExports.useListProfileTenants;
export const useLazyListProfileTenants: typeof hookExports.useLazyListProfileTenants =
  hookExports.useLazyListProfileTenants;
export const useVerifyTelegram: typeof hookExports.useVerifyTelegram =
  hookExports.useVerifyTelegram;
